<script>
    import { apiMethods } from "../../Services/index.svelte";

    import {
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";

    import {
        getAnnouncementsType,
        getFormatDate,
        getText,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";
    import CardLayout from "../../Components/Common/CardLayout.svelte";

    export let params;

    let isLoadingAnnouncement = false,
        announcementDetails = {};

    $: if (params.id) loadAnnouncement(params.id);

    const loadAnnouncement = async (id) => {
        isLoadingAnnouncement = true;

        await apiMethods.getMethod
            .getAnnouncementById(id)
            .then((res) => {
                if (!res.id || res.error)
                    showError(
                        "Failed to load announcement, please try again later or contact support",
                    );
                else announcementDetails = { ...res };
            })
            .catch((err) => showException(err));

        isLoadingAnnouncement = false;
    };

</script>

<PageHead
    title="View Announcement"
/>

{#if isLoadingAnnouncement}
    <PageLoading />
{:else}
    <CardLayout title="Announcement details">
        <div class="flex flex-col gap-2 p-2">
            <div
                class="flex flex-col flex-1 px-2 py-4 gap-y-4 w-full lg:flex-row"
            >
                <div
                    class="flex flex-col flex-1 gap-y-4 h-full"
                >
                    <div class="flex gap-x-4">
                        <p class="title">ID:</p>

                        <p class="content">
                            {getText(announcementDetails.id)}
                        </p>
                    </div>

                    <div class="flex gap-x-4">
                        <p class="title">Type:</p>

                        <p class="content">
                            {getAnnouncementsType(
                                announcementDetails.type,
                            )}
                        </p>
                    </div>
                </div>

                <div class="divider lg:divider-horizontal" />

                <div
                    class="flex flex-col flex-1 gap-y-4 h-full"
                >
                    <div class="flex gap-x-4">
                        <p class="title">Create Date:</p>

                        <p class="content">
                            {getFormatDate(
                                announcementDetails.createdDate,
                            )}
                        </p>
                    </div>

                    <div class="flex gap-x-4">
                        <p class="title">Last Update Date:</p>

                        <p class="content">
                            {getFormatDate(
                                announcementDetails.updatedDate,
                            )}
                        </p>
                    </div>
                </div>
            </div>

            <div class="flex flex-col flex-1 px-2 mt-4 gap-2">
                <p class="title">Subject:</p>
                <p class="content ml-2">
                    {announcementDetails.subject}
                </p>
            </div>

            <div class="flex flex-col flex-1 px-2 mt-4 gap-2">
                <p class="title">Content:</p>
                <p class="content ml-2">
                    {announcementDetails.content}
                </p>
            </div>
        </div>
    </CardLayout>
{/if}

<style>
    .title {
        width: 150px;
    }

    .content {
        width: calc(100% - 150px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
